import { render, staticRenderFns } from "./ExamResultsAnnouncementPage.vue?vue&type=template&id=63f457fa&scoped=true"
import script from "./ExamResultsAnnouncementPage.vue?vue&type=script&lang=js"
export * from "./ExamResultsAnnouncementPage.vue?vue&type=script&lang=js"
import style0 from "./ExamResultsAnnouncementPage.vue?vue&type=style&index=0&id=63f457fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f457fa",
  null
  
)

export default component.exports